// Sunucu tarafı küçültme: /api/product-images ve /api/uploads görsellerine ?w= ekler
let imgVersion = '';
try { imgVersion = localStorage.getItem('app_cache_version') || ''; } catch { /* ignore */ }
export const setImgVersion = (v) => { imgVersion = v || ''; };

export const imgUrl = (url, w) => {
  if (!url || typeof url !== 'string') return url;
  if (!/\/api\/(product-images|uploads)\//.test(url) || /[?&]w=/.test(url)) return url;
  return `${url}${url.includes('?') ? '&' : '?'}w=${w}${imgVersion ? `&v=${imgVersion}` : ''}`;
};
